import { get } from "../client";
import { GET_STATISTICS } from "../routes";

export default {
  get_statistics: async () => await get(GET_STATISTICS),
};
